// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Eventos · Plataforma (backoffice) — la pantalla comparte las tarjetas, las
   franjas y los botones de fila con la cola de payouts (PlataformaPagos.css).
   Lo único suyo es el filtro por estado del evento: un grupo de chips en la
   cabecera de la franja, que no existe en la otra pantalla porque sus carriles
   son pestañas, y el cuerpo crudo del evento, que la otra pantalla no tiene.
   Tokens del design system; sin hex sueltos. */

.plp-evfilters {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 6px;
}
.plp-evfilter {
  height: 24px;
  padding: 0 10px;
  border: 1px solid var(--border);
  border-radius: var(--radius-0);
  background: transparent;
  color: var(--text-secondary);
  font-family: var(--mono);
  font-size: var(--fs-micro);
  letter-spacing: 0.14em;
  text-transform: uppercase;
  cursor: pointer;
  white-space: nowrap;
}
.plp-evfilter:hover {
  border-color: var(--text-muted);
  color: var(--text);
}
.plp-evfilter.is-on {
  border-color: var(--ink-dark);
  background: var(--ink-dark);
  color: var(--cream);
}
[data-theme='dark'] .plp-evfilter.is-on {
  border-color: var(--cream);
  background: var(--cream);
  color: var(--ink-dark);
}

/* cuerpo crudo del evento, colapsado por fila */
.plp-raw {
  margin-top: 10px;
}
.plp-raw__body {
  margin: 10px 0 0;
  max-height: 320px;
  overflow: auto;
  padding: 12px 14px;
  border: 1px solid var(--border-soft);
  border-radius: var(--r-data);
  background: var(--bg);
  font-family: var(--mono);
  font-size: var(--fs-sm);
  line-height: 1.45;
  color: var(--text-secondary);
  white-space: pre;
  tab-size: 2;
}
`, "",{"version":3,"sources":["webpack://./src/pages/plataforma/PlataformaEventos.css"],"names":[],"mappings":"AAAA;;;;;+CAK+C;;AAE/C;EACE,oBAAoB;EACpB,eAAe;EACf,QAAQ;AACV;AACA;EACE,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,8BAA8B;EAC9B,uBAAuB;EACvB,4BAA4B;EAC5B,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA,gDAAgD;AAChD;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;EACvB,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,WAAW;AACb","sourcesContent":["/* Eventos · Plataforma (backoffice) — la pantalla comparte las tarjetas, las\n   franjas y los botones de fila con la cola de payouts (PlataformaPagos.css).\n   Lo único suyo es el filtro por estado del evento: un grupo de chips en la\n   cabecera de la franja, que no existe en la otra pantalla porque sus carriles\n   son pestañas, y el cuerpo crudo del evento, que la otra pantalla no tiene.\n   Tokens del design system; sin hex sueltos. */\n\n.plp-evfilters {\n  display: inline-flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n.plp-evfilter {\n  height: 24px;\n  padding: 0 10px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-0);\n  background: transparent;\n  color: var(--text-secondary);\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.plp-evfilter:hover {\n  border-color: var(--text-muted);\n  color: var(--text);\n}\n.plp-evfilter.is-on {\n  border-color: var(--ink-dark);\n  background: var(--ink-dark);\n  color: var(--cream);\n}\n[data-theme='dark'] .plp-evfilter.is-on {\n  border-color: var(--cream);\n  background: var(--cream);\n  color: var(--ink-dark);\n}\n\n/* cuerpo crudo del evento, colapsado por fila */\n.plp-raw {\n  margin-top: 10px;\n}\n.plp-raw__body {\n  margin: 10px 0 0;\n  max-height: 320px;\n  overflow: auto;\n  padding: 12px 14px;\n  border: 1px solid var(--border-soft);\n  border-radius: var(--r-data);\n  background: var(--bg);\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  line-height: 1.45;\n  color: var(--text-secondary);\n  white-space: pre;\n  tab-size: 2;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
